import { Injectable } from '@angular/core';

import { SecretaryAPIResponse, SecretaryInterface } from '../interfaces/secretary';
import { IdentifierAPIResponse } from '../interfaces/identifier';
import { AddressAdapter } from './address.adapter';
import { QualificationAdapter } from './qualification.adapter';
import { TelecomAdapter } from './telecom.adapter';

@Injectable({
  providedIn: 'root'
})

export class SecretaryAdapter {

    constructor(
      private addressAdapter: AddressAdapter, 
      private qualificationAdapter: QualificationAdapter,
      private telecomAdapter: TelecomAdapter
    ){}

    public adapterToModel(secretaryFHIR: SecretaryAPIResponse) : SecretaryInterface {



      const identifier = this.extractIdentifiers(secretaryFHIR.identifier)
      const telecom = this.telecomAdapter.adapterToModel(secretaryFHIR?.telecom!)

      const address = this.addressAdapter.adapterToModel(secretaryFHIR.address[0])
      const qualifications = this.qualificationAdapter.adapterToModel(secretaryFHIR?.qualification)

      return {
        secretaries_id: secretaryFHIR.secretaries_id,
        name: secretaryFHIR.name,
        gender: secretaryFHIR.gender,
        birthDate: secretaryFHIR.birthDate,
        cpf: identifier.CPF ?? '',
        email: telecom?.email ?? undefined,
        mobile: telecom?.mobile ?? undefined,
        phone: telecom?.mobile ?? undefined,
        avatar: undefined,
        status: secretaryFHIR.status,
        address: address,
        qualifications: qualifications.qualifications,
        certificates:  qualifications.certifications,
        communication: secretaryFHIR.communication,
        token_id: secretaryFHIR.token_id,
        photo: secretaryFHIR.photo
      
      }
    }


    public adaptToAPIFormat(secretaryModel: SecretaryInterface): SecretaryAPIResponse {

      return {
        secretaries_id: secretaryModel.secretaries_id ?? "12345",
        name: secretaryModel.name,
        avatar: undefined,
        identifier: [{ value: secretaryModel.cpf, system: 'CPF' }],
        gender: secretaryModel.gender,
        birthDate: secretaryModel.birthDate,
        telecom: this.telecomAdapter.adaptToAPIFormat(
          secretaryModel.email,
          secretaryModel.phone,
          secretaryModel.mobile,
        ),
        qualification:   secretaryModel.qualifications ? this.qualificationAdapter.adaptToAPIFormat(
          secretaryModel.qualifications, secretaryModel.certificates
        ): [],
        address: secretaryModel.address ?
           this.addressAdapter.adaptToAPIFormat(secretaryModel.address) :
           [],
        communication: secretaryModel.communication ?? [],
        status: secretaryModel.status,
        token_id: secretaryModel.token_id,
        photo: secretaryModel.photo
      }

    }

    private extractIdentifiers(identifiers: IdentifierAPIResponse[]){

      let CPF: string | null = null;
      let CRM: string | null = null;
      let CNPJ: string | null = null;

      identifiers.forEach(identifier => {
          const { system, value } = identifier;
  
          if (system === "CPF") {
            CPF = value;
          } else if (system === "CRM") {
            CRM = value;
          }else if (system === "CNPJ") {
            CNPJ = value;
          }

      });

      return { CPF, CRM, CNPJ };

  }





  

}